import { useEventLogging } from '@AppModels/Logging';
import { IAccount, IAutomationTemplateReference } from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useImpersonationContext } from '../../../../../hooks/useImpersonationContext';
import { useAdminUserSession } from '../../../../../models/hooks/adminStateHooks';
import { AdminPermission } from '../../../../../viewmodels/AdminViewModels';
import { Automations } from '../../../../../web/containers/Automations';
import { styleSheet } from './styles';

interface IProps {
	account: IAccount;
}

const _AccountAutomationsTab: React.FC<IProps> = props => {
	const { account } = props;

	// Hooks
	const history = useHistory();
	const userSession = useAdminUserSession();
	const impersonationContext = useImpersonationContext({ accountId: account.id });
	const { logEvent } = useEventLogging('AccountAutomationsTab');

	// Update user session impersonation context when it changes
	useEffect(() => {
		if (impersonationContext && userSession) {
			userSession.impersonate(impersonationContext);
		}
		return () => {
			if (userSession) {
				userSession.impersonate(null);
			}
		};
	}, [impersonationContext, userSession]);

	const onRequestCreate = () => {
		logEvent('CreateAutomationRequested');
		history.push(`/accounts/${account.id}/automations/new`);
		return true;
	};

	const onRequestEdit = (automationTemplate: IAutomationTemplateReference) => {
		logEvent('EditAutomationRequested', { automationTemplateId: automationTemplate.id });
		history.push(`/accounts/${account.id}/automations/${automationTemplate.id}/canvas`);
		return true;
	};

	const canEditAutomations = userSession.hasPermission(AdminPermission.CreateAutomationTemplateOnBehalf);

	return (
		<div className={css(styleSheet.container)}>
			<Automations
				canEditProp={canEditAutomations}
				hideAppBarHeader={true}
				hideOnHoldAutomations={true}
				impersonationContext={impersonationContext}
				onRequestCreate={onRequestCreate}
				onRequestEdit={onRequestEdit}
				styles={[styleSheet.automationsContainer]}
			/>
		</div>
	);
};

export const AccountAutomationsTab = _AccountAutomationsTab;
